<!-- 用于ERP账单审批-通过条件配置-中的担保方下拉选择组件 -->
<template>
  <div class="isTxt" v-if="isTxt">
    {{ name || '-' }}
  </div>
  <RxkSelect
    v-else
    :list="list"
    v-model="innerValue"
    :disabled="renderConfig.disabled"
    @change="handleChange"
  />
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkSelect } from '@/components/common/RxkSelect'
import { guaranteePage } from '@/apis/erp/guaranteeManage'
import { isNullOrUndefOrEmpty } from '@/utils/is'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList', 'updadeViewData', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const list = ref([])
const name = ref('')

try {
  const data = sessionStorage.getItem('ErpGuarantee') || ''
  list.value = JSON.parse(data) || []
} catch (e) {
  list.value = []
}

onMounted(() => {
  if (list.value.length) {
    getName(list.value)
  } else {
    guaranteePage({
      count: false,
      model: {
        state: 'ENABLED'
      }
    }).then((res: any) => {
      list.value = res.records.map((el: Recordable) => {
        return { label: el.name, value: el.id, ...el }
      })
      sessionStorage.setItem('ErpGuarantee', JSON.stringify(list.value))
      getName(list.value)
    })
  }
})
watch(
  () => props.modelValue,
  () => {
    if (props.data.dataMark !== 2 && props.isTxt) {
      getName(list.value)
    }
  }
)

watch(
  () => props.isTxt,
  val => {
    if (val) {
      getName(list.value)
    }
  }
)

function getName(list: Recordable[]) {
  if (isNullOrUndefOrEmpty(list) || isNullOrUndefOrEmpty(innerValue.value)) {
    name.value = '-'
    return
  }
  const current = list.find(item => String(item.value) === String(innerValue.value))
  name.value = current ? current.label || '-' : '-'
}

function handleChange(e: string | any) {
  emit('blur', e)
}
</script>
